export default __webpack_public_path__ + "static/media/rfactor.93df0610.png";